import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col gap-x-3 px-3 py-5 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "flex flex-row gap-x-3" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "text-gray-lp-500 text-sm" }
const _hoisted_5 = { class: "flex-1 px-3 py-5 rounded-xl border border-gray-lp-1300 content-center" }
const _hoisted_6 = { class: "flex-1 px-3 py-5 rounded-xl border border-gray-lp-1300 font-semibold content-center" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_CodType = _resolveComponent("CodType")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, {
            fontSize: 20,
            label: _ctx.$t('clientManagement.registrationBranchForm.deliveryService.title')
          }, null, 8, ["label"]),
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("clientManagement.registrationBranchForm.deliveryService.description")), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_CheckboxV2, {
            label: _ctx.$t('clientManagement.registrationBranchForm.deliveryService.cashOnDelivery'),
            textSize: 14,
            keyName: "cod",
            key: _ctx.modelValue.isCod,
            value: _ctx.modelValue.isCod,
            "onUpdate:value": _ctx.onCodCheckChange
          }, null, 8, ["label", "value", "onUpdate:value"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_CheckboxV2, {
            label: _ctx.$t('clientManagement.registrationBranchForm.deliveryService.deliveryOrder'),
            textSize: 14,
            onClick: _ctx.onClickDO,
            key: _ctx.modelValue.isDo,
            keyName: "do",
            value: _ctx.modelValue.isDo,
            "onUpdate:value": _ctx.onDoCheckChange
          }, null, 8, ["label", "onClick", "value", "onUpdate:value"])
        ])
      ]),
      (_ctx.modelValue.isCod)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_CodType, {
              modelValue: _ctx.modelValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => (_ctx.error = $event))
            }, null, 8, ["modelValue", "error"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}